export type SettingState = "ENABLED" | "DISABLED";

export function settingState(enabled: boolean): SettingState {
  return enabled ? "ENABLED" : "DISABLED";
}
